import { render, staticRenderFns } from "./yetJoin.vue?vue&type=template&id=5edfbe2a&scoped=true&"
import script from "./yetJoin.vue?vue&type=script&lang=js&"
export * from "./yetJoin.vue?vue&type=script&lang=js&"
import style0 from "./yetJoin.vue?vue&type=style&index=0&id=5edfbe2a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edfbe2a",
  null
  
)

export default component.exports